export function formatKilometer(number: number | null) {
  return (Math.round(((number || 0) / 1000) * 100) / 100).toLocaleString("hu");
}
